import classes from './MessageLinkeable.module.scss'

const MessageLinkeable = ({ style, onClick, message }) => (
    <div style={style} className={classes.root} onClick={onClick}>
        {message}
    </div>
);

export default MessageLinkeable;
